import React, { useState } from 'react';
import { SignupData } from '../../../pages/SignupPage';
import { XIcon } from 'lucide-react';
interface ManagerFormProps {
  updateDetails: (details: any) => void;
  data: SignupData;
}
const ManagerForm: React.FC<ManagerFormProps> = ({
  updateDetails,
  data
}) => {
  const [teamInput, setTeamInput] = useState('');
  const handleAddTeam = () => {
    if (teamInput.trim() !== '') {
      const currentTeams = data.profileDetails?.teamsManaged || [];
      updateDetails({
        teamsManaged: [...currentTeams, teamInput.trim()]
      });
      setTeamInput('');
    }
  };
  const handleRemoveTeam = (index: number) => {
    const currentTeams = [...(data.profileDetails?.teamsManaged || [])];
    currentTeams.splice(index, 1);
    updateDetails({
      teamsManaged: currentTeams
    });
  };
  return <div className="space-y-4" data-id="element-122">
      <div data-id="element-123">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-124">
          Management Specialty
        </label>
        <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. Team Management, Sports Administration" value={data.profileDetails?.managementSpecialty || ''} onChange={e => updateDetails({
        managementSpecialty: e.target.value
      })} data-id="element-125" />
      </div>
      <div data-id="element-126">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-127">
          Years of Experience
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 8" value={data.profileDetails?.experience || ''} onChange={e => updateDetails({
        experience: e.target.value
      })} data-id="element-128" />
      </div>
      <div data-id="element-129">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-130">
          Teams Managed
        </label>
        <div className="flex" data-id="element-131">
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg block w-full p-2.5" placeholder="e.g. Manchester United" value={teamInput} onChange={e => setTeamInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), handleAddTeam())} data-id="element-132" />
          <button type="button" className="bg-blue-600 text-white rounded-r-lg px-4" onClick={handleAddTeam} data-id="element-133">
            Add
          </button>
        </div>
        <div className="mt-2" data-id="element-134">
          {(data.profileDetails?.teamsManaged || []).map((team, index) => <div key={index} className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mt-2" data-id="element-135">
              <span className="flex-1" data-id="element-136">{team}</span>
              <button type="button" className="text-gray-500 hover:text-red-500" onClick={() => handleRemoveTeam(index)} data-id="element-137">
                <XIcon size={16} data-id="element-138" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default ManagerForm;